/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDesktopMarkAllAsReadModel,
  IMappers,
  TDesktopMarkAllAsReadResponse,
  TDesktopMarkAllAsReadResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createDesktopMarkAllAsReadModel(): TDesktopMarkAllAsReadModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'notification-center',
    pathApi: '/v1/desktop/mark-all-as-read/',
    response: {
      '200': {},
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IDesktopMarkAllAsReadOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchDesktopMarkAllAsRead<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IDesktopMarkAllAsReadOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDesktopMarkAllAsReadResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDesktopMarkAllAsReadModel(),
    config,
  )) as FetchResponse<TDesktopMarkAllAsReadResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TDesktopMarkAllAsReadResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDesktopMarkAllAsReadResponse>;
}
